<gl-pro-modal (closeModal)="close(false)">
  <p>{{ 'payment_success' | translate }}</p>
</gl-pro-modal>
